import { GetterTree } from "vuex";

import { ToggleMenu } from "./types";
import { RootState } from "../../types";
export const getters: GetterTree<ToggleMenu, RootState> = {
  isMenuOpen(state) {
    return state.isMenuOpen;
  }
};
